module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orderDetails"
  }, [_c('BlockHeader', {
    attrs: {
      "title": _vm.title,
      "faIconClass": "fas fa-shopping-cart"
    }
  }), _vm._v(" "), (_vm.hasItems) ? _c('OrderItems') : _vm._e(), _vm._v(" "), (_vm.hasItems) ? _c('Tll') : _vm._e(), _vm._v(" "), (_vm.hasItems) ? _c('TaxRate') : _vm._e(), _vm._v(" "), (_vm.totalAmount) ? _c('div', {
    staticClass: "orderDetails--totalAmount"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "orderDetails--totalAmount__title"
  }, [_vm._v("\n        " + _vm._s(_vm.totalAmount === '0.00' || _vm.tllRemainingDays ? "Total to pay now" : "Total") + "\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "orderDetails--totalAmount__price"
  }, [_vm._v("\n        " + _vm._s(_vm.currency) + " " + _vm._s(_vm.tllRemainingDays ? "0.00" : _vm.totalAmount) + "\n      ")])]), _vm._v(" "), (_vm.isSubscription) ? _c('span', {
    staticClass: "orderDetails--totalAmount__price"
  }, [_c('BillingFrequency')], 1) : _vm._e(), _vm._v(" "), _c('hr')]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ef4550f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/checkout/components/organisms/OrderDetails.vue
// module id = 539
// module chunks = 2